/**
 * Mock 模块：prob_gift_act_rank
 * 稿面：台座 3 + 行 6 = list 9；mine 对齐第 4 名。
 * @see mockMd/prob_gift_act_rank.md
 */
import {
  storiesAvatar,
  storiesTop1Avatar,
  storiesTop2Avatar,
  storiesTop3Avatar,
} from '../components/LuckyPoolRank/stories-images'
import type {ProbGiftActRankData, ProbGiftActRankItem} from '../types'

const PODIUM_AVATARS = [
  storiesTop1Avatar,
  storiesTop2Avatar,
  storiesTop3Avatar,
] as const

const mockItem = (rank: number): ProbGiftActRankItem => {
  const isPodium = rank <= 3
  return {
    rank,
    mid: 30000 + rank,
    name: isPodium ? 'namena...' : 'namename...',
    avatar: isPodium ? PODIUM_AVATARS[rank - 1] : storiesAvatar,
    score: isPodium ? 17700 : 1000000000,
    estimate_coins: isPodium ? 1222222 : 0,
    gap_to_top3: isPodium ? 0 : 1000,
  }
}

const list = Array.from({length: 9}, (_, i) => mockItem(i + 1))

/** @see mockMd/prob_gift_act_rank.md */
export const ProbGiftActRankMock: ProbGiftActRankData = {
  err_msg: '',
  list,
  mine: {
    ...list[3],
    gap_to_top3: 1000,
  },
  top: 3,
  offset: 9,
  limit: 20,
  more: false,
}
